/*
 * @Project_description: store
 */
'use strict'
import Vue from 'vue'
import Vuex from 'vuex'
import global from './global.js'
import permission from "./permission";

Vue.use(Vuex)
const store = new Vuex.Store({
    modules: {
        global,
        permission
    },
    state: {},
    getters: {
        userInfo: state => state.global.userInfo,
        roles: state => state.global.roles,
        routes: state => state.permission.routes,
        convertRoutes: state => state.permission.convertRoutes,
    },
    mutations: {},
    actions: {},
})
export default store
